import { render, staticRenderFns } from "./walletaccount.vue?vue&type=template&id=13ef516c&"
import script from "./walletaccount.vue?vue&type=script&lang=js&"
export * from "./walletaccount.vue?vue&type=script&lang=js&"
import style0 from "./walletaccount.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports